import chargeStationApi from 'api/chargeStationApi';
import driverApi from 'api/driverApi';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// lay danh sach giao dich thanh toan
export const thunkGetPaymentTransactionList = createAsyncThunk(
  'paymentTransaction/thunkGetPaymentTransactionList',
  async (driverId, params, thunkAPI) => {
    if (typeof driverId === "string") {
      return await driverApi.getDriverTransactionHistory(driverId, params);
    } else {
      return await chargeStationApi.getChargeStationList(params);
    }
  }
);

// ---- params ----
const initialState = {
  isGettingData: false,
  paymentTransactionList: [],
  topupTransactionList: [],
  total: 0,
};

const paymentTransactionSlice = createSlice({
  name: 'paymentTransaction',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkGetPaymentTransactionList.pending, (state, action) => {
        state.isGettingData = true;
      })
      .addCase(thunkGetPaymentTransactionList.rejected, (state, action) => {
        state.isGettingData = false;
      })
      .addCase(thunkGetPaymentTransactionList.fulfilled, (state, action) => {
        state.isGettingData = false;
        const { result, payments, topups, total } = action.payload;
        if (result === 'success') {
          state.paymentTransactionList = payments ?? [];
          state.topupTransactionList = topups ?? [];
          state.total = total ?? 0;
        }
      });
  },
});

const { reducer, actions } = paymentTransactionSlice;
export const { } = actions;
export default reducer;
